export function secondsToReadableTime(seconds) {
    seconds = Number(seconds);

    return {
        'days':  Math.floor(seconds / (3600 * 24)),
        'hours':  Math.floor(seconds % (3600 * 24) / 3600),
        'min': Math.floor(seconds % 3600 / 60)
    }
}
